import { createReducer } from "@reduxjs/toolkit";
import { adminRetrieveAdmins } from "./retrieve-admin-list";
import type { AdminVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<AdminVM[]> = { data: [], fetching: "idle" };

export const adminRetrieveAdminsReducer = createReducer<RetrievalState<AdminVM[]>>(initialState, builder => {
  builder.addCase(adminRetrieveAdmins.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveAdmins.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveAdmins.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
